var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.parts),function(part,index){return [(_vm.linkRegex.test(part))?_c('a',{key:index,staticClass:"link-wrapper",attrs:{"href":part,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(part))]):_c('span',{key:index},[_vm._v(_vm._s(part))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }